import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Spinner from 'react-bootstrap/Spinner'
import Login from "./Components/Login";
import Signup from "./Components/Signup";
import Home from "./Components/home/home";
import Header from "./Components/header";
import ProductDetails from "./Components/productDetails/productDetails";
import Error from "./Components/error";
import CheckOut from "./Components/checkOut/checkOut";
import CartDetails from "./Components/cartDetails/cartDetails";
import PaymentSuccess from "./Components/payment/paymentSuccess";

function App() {
  return (
    <>
      <BrowserRouter>
        <Header />
        <div id="showSpinner" hidden>
          <div className="loading">
            <Spinner animation="border" variant="primary" />
          </div>
        </div>
        <Routes>
          <Route path="/" element={<Navigate replace to="/Home" />} />
          <Route path="*" element={<Error />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Signup" element={<Signup />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/checkOut" element={<CheckOut />} />
          <Route path="/cartDetails" element={<CartDetails />} />
          <Route path="/Payments/PaymentSuccess" element={<PaymentSuccess />} />
          <Route path="/Payments/PaymentCancel" element={<CartDetails />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;